<template>
  <div style=" position: fixed;top: 0;z-index: 1000;width: 100%;">
    <!-- <div class="navbar-top">
      <div class="navbar-top-contain flex-h flex-vc">
        <div class="gongzhong-icon">
          <img width="100%;" height="100%" src="../assets/indexIcon/navicon2.png" alt />
          <img class="gongzhong-img" width="100px" src="../assets/gongzhonghao.jpg" alt />
        </div>
        <div @click="toushu" style="width:24px;height:24px;cursor: pointer;">
          <img
            width="100%;"
            height="100%"
            src="../assets/indexIcon/navicon1.png"
            alt="投诉建议"
            title="投诉建议"
          />
        </div>
        <div class="flex1" style="font-size: 12px;color:#47EBA4;text-align:right;">
          <img
            style="vertical-align: text-top;margin-right:6px;"
            width="13px;"
            height="13px"
            src="../assets/indexIcon/navicon3.png"
            alt
          />
          全国服务热线：0755-86705865
        </div>
      </div>
    </div> -->
    <div class="contain">
      <div class="navbar-box flex-h">
        <div class="navbar-left">
          <a href="/">
            <img width="65px" height="25px" src="../assets/logo.png" alt="上户" />
          </a>
        </div>

        <div class="navbar-right flex1">
          <ul class="ul-box">
            <li @click="itemClick(item,index)" v-for="(item,index) in tabs" :key="index">
              <div class="textBox">
                <span :style="tabState==index?'color:#00A14D;':''">{{item.txet}}</span>
                <img v-if="index==4" src="../assets/cityPartner/fire.png" alt="">
              </div>
              <div class="nav-bot" v-if="tabState==index"></div>
            </li>
          </ul>
        </div>
        <div @click="goLogin" class="login-li flex-h flex-vc">
          <div v-if="backstageUserImgS" class="img-box"
            :style="{backgroundImage:'url('+backstageUserImgS+')'}"></div>
          <div v-else class="img-box" :style="{backgroundImage:'url('+backstageUserImgN+')'}"></div>

          <div v-if="backstageUserName">{{backstageUserName}}</div>
          <div v-else>企业登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 这个是配置head信息，vue-meta-info插进提供的功能
  metaInfo: {
    title: "上户-家政好工作，高薪上户快", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "上户,家政,保姆,月嫂,育婴师,育儿嫂,钟点工,护工,招聘,求职,家政阿姨,家政招聘",
      },
      {
        name: "description",
        content:
          "上户家政招聘求职平台，为家政公司找家政阿姨，帮助家政阿姨快速上户",
      },
    ],
    link: [
      {
        // set link
        rel: "shortcut icon",
        href: "http://jiazheng52.com/jzPc/static/img/favicon.ico",
      },
    ],
  },
  props: ["tabState"],
  data () {
    return {
      backstageUserName: "",
      backstageUserImgS: "",
      backstageUserImgN: require("../assets/touxiang.png"),
      tabs: [
        { txet: "首页", goRoute: "/" },
        { txet: "上户APP", goRoute: "/apps" },
        { txet: "会员权益", goRoute: "/membersPower" },
        { txet: "上户动态", goRoute: "/news" },
        { txet: "城市合伙人", goRoute: "/cityPartner" },
        { txet: "关于我们", goRoute: "/about" },
      ],
      staticData: "这是data里的静态数据",
      forComputed: 10,
      list: [],
    };
  },
  mounted () {
    if (this.getCookie("U_id")) {
      if (this.getCookie("U_name")) {
        this.backstageUserName = this.getCookie("U_name");
      }
      if (this.getCookie("U_portrait")) {
        this.backstageUserImgS = this.getCookie("U_portrait");
      }
    }
  },
  computed: {
    staticComputed () {
      return "这是计算属性里的静态数据" + this.forComputed * 66;
    },
    listLength () {
      return this.list.length;
    },
  },
  methods: {
    toushu () {
      this.$router.push("/advice");
    },
    itemClick (item, index) {
      let obj = {};
      obj.index = index;
      obj.goRoute = item.goRoute;
      this.$emit("itemClick", obj)
    },
    goLogin () {
      if (this.getCookie("U_id")) {
        this.$router.push("/myCenter");
      } else {
        this.$router.push("/login");
      }
    },
  },
};
</script>
 <style lang="less" scoped>
.navbar-top {
  width: 100%;
  height: 40px;
  background: #00a14d;
  .navbar-top-contain {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .gongzhong-icon {
      width: 24px;
      height: 24px;
      margin-right: 14px;
      position: relative;
      cursor: pointer;
      .gongzhong-img {
        z-index: 2;
        position: absolute;
        border-radius: 6px;
        top: 32px;
        left: 0;
        display: none;
      }
    }
    .gongzhong-icon:hover .gongzhong-img {
      display: block;
    }
  }
}
.contain {
  width: 100%;

  background: #24352d;
  height: 60px;
  box-shadow: 0px 3px 11px 0px rgba(240, 240, 240, 0.68);
}
.navbar-box {
  margin: 0 auto;
  width: 1200px;
  height: 60px;
  line-height: 60px;
  color: #dddddd;

  .navbar-left {
    text-align: left;
    img {
      vertical-align: middle;
    }
  }
  .navbar-right {
    text-align: center;
  }
  .login-li {
    font-size: 14px;
    cursor: pointer;
    .img-box {
      border: 1px solid #00a14d;
      margin-right: 13px;
      background-size: cover;
      background-position: 50%, 50%;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #f7f9f8;
    }
    div:hover {
      color: #00a14d;
    }
  }
}
.ul-box {
  padding: 0;
  display: inline-block;
  height: 60px;

  li {
    list-style: none;
    float: left;
    padding: 0 30px;
    position: relative;
    cursor: pointer;
    font-size: 14px;
    .textBox {
      display: flex;
      align-items: center;
      flex-direction: row;
      img {
        width: 13px;
        height: 17px;
        display: block;
        margin-top: -13px;
      }
    }

    .nav-bot {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 11px;
      height: 2px;
      background: #00a14d;
      transform: translateX(-50%);
    }
  }
  li:hover {
    color: #00a14d;

    background: rgba(0, 0, 0, 0.1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/navbar.vue